import PropTypes from "prop-types";
import { reusableComponentSizes } from "core/props";

// convertToRem ex: 40 => 2.5rem
// change 16 if our base px size ever changes
export const convertPxToRem = ({ px }) => {
    if (typeof px !== "number") return "0rem";

    const pxToRem = px / 16;
    return `${pxToRem}rem`;
};

convertPxToRem.propTypes = {
    px: PropTypes.number.isRequired
};

export const handleComponentSize = ({ size, styles }) => {
    switch (size) {
        case "xs":
            return styles.XS;
        case "sm":
            return styles.SM;
        case "md":
            return styles.MD;
        case "lg":
            return styles.LG;
        default:
            return styles.LG;
    }
};

handleComponentSize.propTypes = {
    size: PropTypes.oneOf(reusableComponentSizes).isRequired,
    styles: PropTypes.object.isRequired
};

export const convertCentsToDollars = ({ cents }) => {
    if (typeof cents !== "number") return null;

    const converted = cents / 100;
    return parseFloat(converted.toFixed(2));
};

convertCentsToDollars.propTypes = {
    cents: PropTypes.number.isRequired
};

// returns a string
export const roundToHundredth = ({ num }) => {
    return num.toFixed(2);
};

roundToHundredth.propTypes = {
    num: PropTypes.oneOf([PropTypes.string, PropTypes.number]).isRequired
};
